import { Reveal } from "@/components/Reveal";

const Intro = () => {
  return (
    <section
      id="intro"
      data-testid="intro-section"
      className="relative bg-ivory py-28 md:py-44 overflow-hidden"
    >
      {/* Decorative background image */}
      <div
        className="absolute inset-0 bg-center bg-cover"
        style={{ backgroundImage: "url('/images/5-pathways.png')" }}
        aria-hidden="true"
      />
      {/* Subtle overlay — matches home hero treatment so the image stays visible */}
      <div
        className="absolute inset-0 bg-gradient-to-t from-forest/70 via-transparent to-charcoal/20"
        aria-hidden="true"
      />
      {/* Soft dark veil for text legibility */}
      <div className="absolute inset-0 bg-charcoal/45" aria-hidden="true" />

      <div className="relative mx-auto max-w-[1600px] px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <div className="lg:col-span-6 lg:col-start-1">
          <Reveal>
            <p className="kicker text-gold mb-8">The Svara Chakra philosophy</p>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="font-serif font-light text-ivory text-4xl md:text-5xl lg:text-6xl leading-[1.08] tracking-tight text-balance">
              We believe wellbeing is not something you chase, but something you
              <span className="text-gold italic"> remember</span>.
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-10 text-ivory/85 leading-relaxed max-w-xl md:text-lg">
              Svara Chakra is a sanctuary devoted to the belief that every individual carries an innate capacity for wellbeing.
            </p>
            <p className="mt-6 text-ivory/85 leading-relaxed max-w-xl md:text-lg">
              Every person carries an innate wisdom, an inner rhythm, and a natural capacity to heal. Through the transformative power of Music Therapy, the subtle energies of Reiki and Crystal Healing, the insights of Numerology, the practice of Mindfulness, and holistic Wellbeing Education, we create compassionate spaces where healing unfolds naturally.
            </p>
            <p className="mt-6 text-ivory/85 leading-relaxed max-w-xl md:text-lg">
              Here, science meets soul, sound becomes medicine, and every journey gently leads you back to yourself.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Intro;
